"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _bwaDeliveryPillRenderHandler = _interopRequireDefault(require("./bwa-delivery-pill-render-handler"));
var BwaDeliveryPill = exports["default"] = /*#__PURE__*/function () {
  function BwaDeliveryPill() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, BwaDeliveryPill);
    if (document.readyState === "complete" || document.readyState === "interactive") {
      this.initRenderHandler();
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        return _this.initRenderHandler();
      });
    }
  }
  return (0, _createClass2["default"])(BwaDeliveryPill, [{
    key: "initRenderHandler",
    value: function () {
      var _initRenderHandler = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var bwaDeliveryPillRenderHandler;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              bwaDeliveryPillRenderHandler = new _bwaDeliveryPillRenderHandler["default"]();
              _context.next = 3;
              return bwaDeliveryPillRenderHandler.executeHandler();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function initRenderHandler() {
        return _initRenderHandler.apply(this, arguments);
      }
      return initRenderHandler;
    }()
  }]);
}();
//# sourceMappingURL=bwa-delivery-pill.js.map
